import axios from 'axios';
import {ApiResponse} from '@interface/common';
import {ChangePassword, UserFind, UserPassword} from '@interface/master/UserManagementIF';


export const callChangePassword = async(param: ChangePassword | undefined) =>  {
    const {data} = await axios.post<ApiResponse<boolean>>('/api/common/change-password', param);
    return data;
};

/** 비밀번호 찾기 후 재설정 (세션 없이 userId 기준) */
export const callChangePassword2 = async(param: ChangePassword | undefined) =>  {
    const {data} = await axios.post<ApiResponse<boolean>>('/api/common/change-password2', param);
    return data;
};

/** 아이디 찾기 (이름 + 휴대폰번호) */
export const callFindUserId = async(param: UserFind) =>  {
    const {data} = await axios.post<ApiResponse<UserFind>>('/api/common/find-id', param);
    return data;
};

/** 비밀번호 찾기 (아이디 + 이름 + 휴대폰번호 대조) — 일치하면 userSeq/userId 반환 */
export const callFindUserPassword = async(param: UserFind) =>  {
    const {data} = await axios.post<ApiResponse<UserFind>>('/api/common/find-password', param);
    return data;
};

/** 로그인 사용자의 비밀번호 해시 (관리자 사이트 편의 로그인 URL 생성용) */
export const getUserPassword = async() =>  {
    const {data} = await axios.get<ApiResponse<UserPassword>>('/api/common/password');
    return data;
};
